import { render, staticRenderFns } from "./pageFooter.vue?vue&type=template&id=1c0bce3e&scoped=true&"
import script from "./pageFooter.vue?vue&type=script&lang=js&"
export * from "./pageFooter.vue?vue&type=script&lang=js&"
import style0 from "./pageFooter.vue?vue&type=style&index=0&id=1c0bce3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0bce3e",
  null
  
)

export default component.exports